import React, { useEffect, useMemo, useState } from "react";
import { HERO_QUOTES } from "../data/quotes";

const pickRandomIndex = (excludeIdx, len) => {
  if (len <= 1) return 0;
  let i = Math.floor(Math.random() * len);
  if (i === excludeIdx) i = (i + 1) % len;
  return i;
};

export default function RotatingQuote() {
  // Start with a random quote on every mount so it never opens with the same line.
  const [i, setI] = useState(() => Math.floor(Math.random() * HERO_QUOTES.length));

  useEffect(() => {
    const id = setInterval(() => {
      setI((curr) => pickRandomIndex(curr, HERO_QUOTES.length));
    }, 10000);
    return () => clearInterval(id);
  }, []);

  return (
    <h1
      key={i}
      className="font-heading text-4xl sm:text-5xl lg:text-6xl xl:text-7xl font-medium tracking-tight leading-[1.04] text-balance animate-quote-in"
      data-testid="hero-rotating-quote"
    >
      {HERO_QUOTES[i].split('"').join("")}
    </h1>
  );
}
